import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "pt-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_btn_primary = _resolveComponent("v-btn-primary")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_RuleTable = _resolveComponent("RuleTable")!
  const _component_ComputedIndicatorCreator = _resolveComponent("ComputedIndicatorCreator")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_ScopeManager = _resolveComponent("ScopeManager")!
  const _component_oss_dialog = _resolveComponent("oss-dialog")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, {
    "grid-list-md": "",
    fluid: ""
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_row, {
        "no-gutters": "",
        class: "d-flex justify-center"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, { cols: "12" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_row, {
                "no-gutters": "",
                cols: "12",
                class: "my-3 justify-center"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, { cols: "2" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_btn_primary, {
                        block: "",
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.open_CI_creator()))
                      }, {
                        default: _withCtx(() => _cache[12] || (_cache[12] = [
                          _createTextVNode(" Ajouter ")
                        ])),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, {
                    cols: "10",
                    class: "pl-2"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_text_field, {
                        modelValue: _ctx.search,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.search) = $event)),
                        "append-inner-icon": "$search",
                        clearable: "",
                        "onClick:clear": _cache[2] || (_cache[2] = ($event: any) => (_ctx.search = '')),
                        label: "Recherche",
                        outlined: "",
                        "hide-details": "",
                        density: "compact"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_RuleTable, {
            rule: 'computedIndicator',
            items: _ctx.filteredComputedIndicators,
            getTitle: _ctx.displayIndicatorName,
            hideDuplication: true,
            accountingCompanyId: _ctx.companyId,
            patternCount: _ctx.computedIndicatorCount,
            pagination: _ctx.pagination,
            firstRequestDone: _ctx.firstRequestDone,
            maxHeight: _ctx.maxHeightRT,
            onToRoute: _cache[3] || (_cache[3] = ($event: any) => (_ctx.open_CI_creator($event))),
            onDelete: _cache[4] || (_cache[4] = ($event: any) => {
                    _ctx.computedIndicatorToDelete = $event;
                    _ctx.deleteDialog = true;
                })
          }, null, 8, ["items", "getTitle", "accountingCompanyId", "patternCount", "pagination", "firstRequestDone", "maxHeight"])
        ]),
        _: 1
      }),
      _createVNode(_component_oss_dialog, {
        modelValue: _ctx.CI_creatorDialog,
        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.CI_creatorDialog) = $event)),
        "min-width": "80vw",
        title: _ctx.selectedIndicator ? 'Modifier un indicateur' : 'Créer un nouvel indicateur',
        hideValid: _ctx.selectedIndicatorIsReadonly,
        actions: _ctx.CI_creatorActions
      }, {
        default: _withCtx(() => [
          _cache[13] || (_cache[13] = _createElementVNode("h2", null, "Le nouvel indicateur :", -1)),
          _createVNode(_component_ComputedIndicatorCreator, {
            incomingData: _ctx.selectedIndicator,
            companyId: _ctx.companyId,
            readOnly: _ctx.selectedIndicatorIsReadonly,
            actions: _ctx.CI_creatorActions,
            scopeId: _ctx.scopeId,
            watchScope: true,
            onComputedIndicatorSavedInBDD: _cache[5] || (_cache[5] = ($event: any) => (_ctx.CI_created($event)))
          }, null, 8, ["incomingData", "companyId", "readOnly", "actions", "scopeId"]),
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_component_v_divider),
            _createVNode(_component_ScopeManager, {
              modelValue: _ctx.scopeSync,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.scopeSync) = $event)),
              id: _ctx.scopeId,
              "onUpdate:id": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.scopeId) = $event)),
              name: _ctx.scopeName,
              "onUpdate:name": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.scopeName) = $event)),
              readonly: _ctx.selectedIndicatorIsReadonly
            }, null, 8, ["modelValue", "id", "name", "readonly"])
          ])
        ]),
        _: 1
      }, 8, ["modelValue", "title", "hideValid", "actions"]),
      _createVNode(_component_oss_dialog, {
        modelValue: _ctx.deleteDialog,
        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.deleteDialog) = $event)),
        title: "Supprimer",
        error: true,
        onClose: _cache[11] || (_cache[11] = ($event: any) => (_ctx.computedIndicatorToDelete = undefined)),
        onValid: _ctx.deletePattern,
        validLoading: _ctx.deleteLoading,
        width: "800px"
      }, {
        default: _withCtx(() => _cache[14] || (_cache[14] = [
          _createElementVNode("h4", { class: "text-center" }, "Êtes-vous sûr(e) de vouloir supprimer cet indicateur ?", -1)
        ])),
        _: 1
      }, 8, ["modelValue", "onValid", "validLoading"])
    ]),
    _: 1
  }))
}